enum UserNotificationType {
  NOTIFICATION = 'NOTIFICATION',
  COMMUNICATION = 'COMMUNICATION',
}

export { UserNotificationType };
